const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCnnIndonesiaNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225px",
    height: "225px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cc0201",
    d: "M -0.5,-0.5 C 74.5,-0.5 149.5,-0.5 224.5,-0.5C 224.5,74.5 224.5,149.5 224.5,224.5C 149.5,224.5 74.5,224.5 -0.5,224.5C -0.5,149.5 -0.5,74.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf8f7",
    d: "M 54.5,53.5 C 61.5,53.5 68.5,53.5 75.5,53.5C 75.5,56.8333 75.5,60.1667 75.5,63.5C 53.5081,59.3979 39.0081,67.7312 32,88.5C 30.8216,107.317 39.3216,119.15 57.5,124C 68.1667,124.667 78.8333,124.667 89.5,124C 90.9308,123.535 92.0975,122.701 93,121.5C 93.3333,103.5 93.6667,85.5 94,67.5C 94.5613,66.9781 95.228,66.6448 96,66.5C 97.7674,67.34 99.1007,68.6734 100,70.5C 110.122,88.5802 120.622,106.414 131.5,124C 133.833,124.667 136.167,124.667 138.5,124C 139.126,123.25 139.626,122.416 140,121.5C 140.333,103.5 140.667,85.5 141,67.5C 142.333,66.1667 143.667,66.1667 145,67.5C 155.537,86.7459 166.704,105.579 178.5,124C 180.833,124.667 183.167,124.667 185.5,124C 186.126,123.25 186.626,122.416 187,121.5C 187.5,98.8358 187.667,76.1691 187.5,53.5C 190.833,53.5 194.167,53.5 197.5,53.5C 197.667,76.8357 197.5,100.169 197,123.5C 192.957,133.603 185.79,136.77 175.5,133C 173.391,131.859 171.558,130.359 170,128.5C 163.667,117.833 157.333,107.167 151,96.5C 150.667,105.833 150.333,115.167 150,124.5C 146.371,132.564 140.205,135.731 131.5,134C 127.421,131.925 123.921,129.092 121,125.5C 115.333,115.5 109.667,105.5 104,95.5C 103.667,105.167 103.333,114.833 103,124.5C 101.073,129.428 97.5732,132.594 92.5,134C 80.1667,134.667 67.8333,134.667 55.5,134C 28.6489,125.798 18.1489,107.965 24,80.5C 30.0281,66.6284 40.1947,57.6284 54.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf7f7",
    d: "M 125.5,90.5 C 125.783,91.2891 126.283,91.9558 127,92.5C 127.5,83.8397 127.666,75.1731 127.5,66.5C 130.099,54.8964 137.099,51.0631 148.5,55C 150.96,56.4578 153.127,58.2911 155,60.5C 161.097,70.3635 166.931,80.3635 172.5,90.5C 172.783,91.2891 173.283,91.9558 174,92.5C 174.5,79.5043 174.667,66.5043 174.5,53.5C 177.5,53.5 180.5,53.5 183.5,53.5C 183.5,76.1667 183.5,98.8333 183.5,121.5C 180.358,121.201 178.191,119.534 177,116.5C 167.086,99.0023 156.919,81.669 146.5,64.5C 143.386,62.9377 140.553,63.2711 138,65.5C 137.827,84.0734 137.327,102.573 136.5,121C 134.633,121.711 133.133,121.211 132,119.5C 121.667,101.5 111.333,83.5 101,65.5C 97.6667,62.8333 94.3333,62.8333 91,65.5C 90.6667,83.5 90.3333,101.5 90,119.5C 89.5,120 89,120.5 88.5,121C 78.5,121.667 68.5,121.667 58.5,121C 39.8913,115.62 32.7246,103.454 37,84.5C 45.3628,69.3044 58.1962,63.6378 75.5,67.5C 75.5,70.8333 75.5,74.1667 75.5,77.5C 69.4908,77.3338 63.4908,77.5005 57.5,78C 47.0934,82.6524 43.5934,90.4857 47,101.5C 49.618,106.116 53.4514,109.283 58.5,111C 65.1667,111.667 71.8333,111.667 78.5,111C 79,110.5 79.5,110 80,109.5C 80.3333,94.1667 80.6667,78.8333 81,63.5C 85.2484,54.4597 92.0817,51.6264 101.5,55C 104.295,56.7932 106.795,58.9598 109,61.5C 114.756,71.0724 120.256,80.739 125.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9aeae",
    d: "M 174.5,53.5 C 174.667,66.5043 174.5,79.5043 174,92.5C 173.283,91.9558 172.783,91.2891 172.5,90.5C 173.167,78.1667 173.833,65.8333 174.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#db7474",
    d: "M 127.5,66.5 C 127.666,75.1731 127.5,83.8397 127,92.5C 126.283,91.9558 125.783,91.2891 125.5,90.5C 126.167,82.5 126.833,74.5 127.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 25.5,144.5 C 26.8333,144.5 28.1667,144.5 29.5,144.5C 29.5,155.167 29.5,165.833 29.5,176.5C 28.1667,176.5 26.8333,176.5 25.5,176.5C 25.5,165.833 25.5,155.167 25.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf2f2",
    d: "M 73.5,144.5 C 74.8333,144.5 76.1667,144.5 77.5,144.5C 77.5,155.167 77.5,165.833 77.5,176.5C 75.8561,176.714 74.3561,176.38 73,175.5C 66.484,178.662 61.484,176.995 58,170.5C 55.8631,162.959 58.0298,157.126 64.5,153C 67.4294,152.223 70.2628,152.39 73,153.5C 73.498,150.518 73.6646,147.518 73.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fae4e3",
    d: "M 171.5,144.5 C 172.873,144.343 174.207,144.51 175.5,145C 176.451,145.718 176.617,146.551 176,147.5C 171.652,150.558 170.152,149.558 171.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbeeee",
    d: "M 35.5,152.5 C 38.8239,153.824 42.1573,153.824 45.5,152.5C 47.9259,152.404 50.0926,153.07 52,154.5C 53.4286,161.719 53.9286,169.053 53.5,176.5C 52.1667,176.5 50.8333,176.5 49.5,176.5C 49.6662,170.158 49.4995,163.825 49,157.5C 46.1993,156.205 43.3659,156.205 40.5,157.5C 39.5037,163.798 39.1703,170.132 39.5,176.5C 38.1667,176.5 36.8333,176.5 35.5,176.5C 35.5,168.5 35.5,160.5 35.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbeceb",
    d: "M 87.5,152.5 C 98.739,151.909 103.572,157.242 102,168.5C 98.5835,177.295 92.7502,179.461 84.5,175C 80.2449,169.72 79.4115,163.886 82,157.5C 83.7297,155.598 85.563,153.931 87.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcefef",
    d: "M 105.5,152.5 C 110.098,152.852 114.765,153.018 119.5,153C 120.667,154.167 121.833,155.333 123,156.5C 123.5,163.158 123.666,169.825 123.5,176.5C 122.167,176.5 120.833,176.5 119.5,176.5C 119.666,170.158 119.5,163.825 119,157.5C 116.199,156.205 113.366,156.205 110.5,157.5C 109.504,163.798 109.17,170.132 109.5,176.5C 108.167,176.5 106.833,176.5 105.5,176.5C 105.5,168.5 105.5,160.5 105.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcf1f0",
    d: "M 146.5,159.5 C 146.5,161.5 146.5,163.5 146.5,165.5C 141.125,165.172 135.792,165.505 130.5,166.5C 130.624,167.107 130.957,167.44 131.5,167.5C 131.886,171.385 134.053,173.385 138,173.5C 140.261,173.135 142.427,172.469 144.5,171.5C 146.003,172.59 146.336,173.757 145.5,175C 134.485,179.948 128.485,176.448 127.5,164.5C 127.652,155.25 132.319,151.416 141.5,153C 144.493,154.159 146.16,156.325 146.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbeceb",
    d: "M 155.5,152.5 C 158.187,152.336 160.854,152.503 163.5,153C 166.817,154.085 167.151,155.585 164.5,157.5C 161.897,156.438 159.23,156.272 156.5,157C 155.167,158.333 155.167,159.667 156.5,161C 160.037,162.281 163.204,164.114 166,166.5C 167.051,175.111 163.218,178.611 154.5,177C 150.85,176.151 150.016,174.317 152,171.5C 155.016,173.472 158.183,173.805 161.5,172.5C 162.848,170.389 162.515,168.555 160.5,167C 153.324,166.179 150.49,162.345 152,155.5C 153.145,154.364 154.312,153.364 155.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbeded",
    d: "M 184.5,152.5 C 188.839,151.846 192.673,152.846 196,155.5C 197.425,162.385 197.925,169.385 197.5,176.5C 194.037,175.563 190.537,175.897 187,177.5C 179.374,175.643 177.541,171.309 181.5,164.5C 185.09,162.031 189.09,161.031 193.5,161.5C 193.579,160.07 193.246,158.736 192.5,157.5C 188.834,156.589 185.168,156.422 181.5,157C 180.549,156.282 180.383,155.449 181,154.5C 182.302,153.915 183.469,153.249 184.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf6f6",
    d: "M 171.5,152.5 C 172.833,152.5 174.167,152.5 175.5,152.5C 175.5,160.5 175.5,168.5 175.5,176.5C 174.167,176.5 172.833,176.5 171.5,176.5C 171.5,168.5 171.5,160.5 171.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cb0201",
    d: "M 65.5,156.5 C 68.1194,156.232 70.6194,156.565 73,157.5C 73.6667,162.167 73.6667,166.833 73,171.5C 68.1546,174.798 64.488,173.798 62,168.5C 60.7452,163.738 61.9119,159.738 65.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cc0a04",
    d: "M 87.5,156.5 C 89.8568,156.337 92.1902,156.503 94.5,157C 97.3597,160.681 98.1931,164.848 97,169.5C 93.74,174.285 90.0734,174.619 86,170.5C 83.6525,165.448 84.1525,160.781 87.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cb0603",
    d: "M 134.5,156.5 C 139.429,155.305 142.429,157.138 143.5,162C 139.514,162.499 135.514,162.666 131.5,162.5C 131.615,160.053 132.615,158.053 134.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e39090",
    d: "M 146.5,159.5 C 147.468,161.607 147.802,163.941 147.5,166.5C 141.974,166.179 136.64,166.512 131.5,167.5C 130.957,167.44 130.624,167.107 130.5,166.5C 135.792,165.505 141.125,165.172 146.5,165.5C 146.5,163.5 146.5,161.5 146.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cd140c",
    d: "M 186.5,165.5 C 188.833,165.5 191.167,165.5 193.5,165.5C 193.5,167.833 193.5,170.167 193.5,172.5C 190.474,173.577 187.474,173.577 184.5,172.5C 182.911,169.412 183.578,167.078 186.5,165.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnnIndonesiaNew);
export default __webpack_public_path__ + "static/media/cnn_indonesia_new.df87b14b26ed0acdd06cf98968186d8f.svg";
export { ForwardRef as ReactComponent };